<script setup lang="ts">
const props = defineProps({
  activeFiltersCount: {
    type: Number,
    default: 0
  },
  iconColor: {
    type: String,
    default: 'primary'
  },
  activeIcon: {
    type: String,
    default: 'mdi-filter-check'
  },
  inactiveIcon: {
    type: String,
    default: 'mdi-filter-check-outline'
  },
  activeText: {
    type: String,
    default: 'active filters'
  },
  inactiveText: {
    type: String,
    default: 'Select your filters'
  },
  maxWidth: {
    type: [String, Number],
    default: 300
  }
})
</script>

<template>
  <v-menu offset-y :close-on-content-click="false">
    <template #activator="{ props: activatorProps, isActive }">
      <v-text-field
        v-bind="activatorProps"
        class="font-weight-bold mx-2"
        :style="'max-width: ' + maxWidth + 'px;'"
        variant="solo"
        flat
        hide-details
        readonly
      >
        <template #prepend-inner>
          <v-icon
            class="mx-1"
            :color="iconColor"
            :icon="activeFiltersCount > 0 ? activeIcon : inactiveIcon"
          />
        </template>

        <template #default>
          <span>
            {{ activeFiltersCount > 0 ? activeFiltersCount + ' ' + activeText : inactiveText }}
          </span>
        </template>

        <template #append-inner>
          <v-icon class="mx-1" :icon="isActive ? 'mdi-chevron-up' : 'mdi-chevron-down'" />
        </template>
      </v-text-field>
    </template>
    <slot></slot>
  </v-menu>
</template>

<style scoped>
.v-input :deep(.v-input__control .v-field:hover) {
  cursor: pointer;
}

.v-input :deep(.v-input__control input) {
  cursor: pointer;
}
</style>
